import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _regeneratorRuntime from '@babel/runtime/regenerator';
var PictureInPicture = function () {
    function PictureInPicture(player) {
        var _this = this;
        _classCallCheck(this, PictureInPicture);
        this.player = player;
        var pipWindow;
        this.player.template.pictureInPictureButton.addEventListener('click', _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                    case 0:
                        _this.player.template.pictureInPictureButton.disabled = true;
                        _context.prev = 1;
                        console.log(_this.player.template);
                        if (!(_this.player.template.video !== document.pictureInPictureElement)) {
                            _context.next = 8;
                            break;
                        }
                        _context.next = 6;
                        return _this.player.template.video.requestPictureInPicture();
                    case 6:
                        _context.next = 10;
                        break;
                    case 8:
                        _context.next = 10;
                        return document.exitPictureInPicture();
                    case 10:
                        _this.player.video.play();
                        _context.next = 16;
                        break;
                    case 13:
                        _context.prev = 13;
                        _context.t0 = _context['catch'](1);
                        console.log('> Argh! '.concat(_context.t0));
                    case 16:
                        _context.prev = 16;
                        _this.player.template.pictureInPictureButton.disabled = false;
                        return _context.finish(16);
                    case 19:
                    case 'end':
                        return _context.stop();
                    }
            }, _callee, null, [[
                    1,
                    13,
                    16,
                    19
                ]]);
        })));
        var onPipWindowResize = function onPipWindowResize() {
            console.log('> Window size changed to '.concat(pipWindow.width, 'x').concat(pipWindow.height));
        };
        this.player.video.addEventListener('enterpictureinpicture', function (event) {
            _this.player.events.trigger('openPicture');
            pipWindow = event.pictureInPictureWindow;
            pipWindow.addEventListener('resize', onPipWindowResize);
        });
        this.player.video.addEventListener('leavepictureinpicture', function () {
            _this.player.events.trigger('endPicture');
            pipWindow.removeEventListener('resize', onPipWindowResize);
        });
        var setPipButton = function setPipButton() {
            _this.player.template.pictureInPictureButton.disabled = _this.player.video.readyState === 0 || !document.pictureInPictureEnabled || _this.player.video.disablePictureInPicture;
        };
        if ('pictureInPictureEnabled' in document) {
            setPipButton;
            this.player.video.addEventListener('loadedmetadata', setPipButton);
            this.player.video.addEventListener('emptied', setPipButton);
        } else {
            this.player.template.pictureInPictureButton.hidden = true;
        }
    }
    return _createClass(PictureInPicture, [
        {
            key: 'hide',
            value: function hide() {
                if (this.player.template.video == document.pictureInPictureElement) {
                    document.exitPictureInPicture();
                }
            }
        },
        {
            key: 'show',
            value: function show() {
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.player.template.video !== document.pictureInPictureElement) {
                    this.player.template.video.requestPictureInPicture();
                } else {
                    document.exitPictureInPicture();
                }
            }
        }
    ]);
}();
export default PictureInPicture;